import React from 'react';
import { useTranslation } from 'react-i18next';

import { LobbyRoom as LobbyRoomType } from '../../../store/types';
import { DesktopStripPage } from '../Desktop/DesktopStripPage';
import { LobbyRoom } from '../Lobby/LobbyRoom';

/** The lobby room card's own proportions (LobbyRoomSection's 226x416). */
const CARD_ASPECT = 226 / 416;

type Props = {
	rooms: LobbyRoomType[];
	loading: boolean;
};

/** The lobby on the desktop frame: the rooms laid out flat instead of on the swipe wheel. */
export const LobbyDesktopRooms = ({ rooms, loading }: Props) => {
	const { t } = useTranslation();

	return (
		<DesktopStripPage
			items={rooms}
			keyOf={room => String(room.id)}
			cardAspect={CARD_ASPECT}
			loading={loading}
			// Open on the second room: the first is VIP, locked for most players, and starting
			// one in leaves a card on either side of the front one.
			initialIndex={Math.min(1, rooms.length - 1)}
			emptyLabel={t('T_SITE_LOBBY_NO_ROOMS', { defaultValue: 'No rooms available' })}
			hintLabel={t('T_SITE_LOBBY_EXPLORE_HINT', { defaultValue: 'Explore rooms' })}
			renderItem={(room, index, size) => (
				<LobbyRoom
					index={index}
					totalCount={rooms.length}
					room={room}
					cardWidth={size.width}
					cardHeight={size.height}
					framed
					shouldRenderSpine={false}
					playing={false}
				/>
			)}
		/>
	);
};

export default LobbyDesktopRooms;
